import { render, staticRenderFns } from "./_DetailsInformationSante.vue?vue&type=template&id=ca7383e6&scoped=true&"
import script from "./_DetailsInformationSante.vue?vue&type=script&lang=ts&"
export * from "./_DetailsInformationSante.vue?vue&type=script&lang=ts&"
import style0 from "./_DetailsInformationSante.vue?vue&type=style&index=0&id=ca7383e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7383e6",
  null
  
)

export default component.exports